import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';

const OpportunityStageInput = () => {
  const { stageId = '' } = useParams();
  const decodedId = stageId ? atob(stageId) : stageId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityStage';

  useEffect(() => {
    if (stageId) {
      setIsEditing(true);
      fetchStageDetails();
    }
  }, [stageId]);

  const fetchStageDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.opportunityStage}${id}/`, { headers });
      setFormData(response.data?.data ?? response.data);
    } catch (error) {
      console.error('Error fetching opportunity stage details:', error);
    }
  };

  const stageFields = [
    { name: 'name', label: 'Stage Name', type: 'text' },
    { name: 'order', label: 'Display Order', type: 'number' },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'probability_percentage', label: 'Win Probability (%)', type: 'number' },
    { name: 'expected_duration_days', label: 'Expected Duration (days)', type: 'number' },
    {
      name: 'stage_type', label: 'Stage Type', type: 'select',
      options: [
        { value: 'open', label: 'Open' },
        { value: 'won', label: 'Won' },
        { value: 'lost', label: 'Lost' },
        { value: 'on_hold', label: 'On Hold' },
      ],
    },
    { name: 'is_active', label: 'Is Active', type: 'checkbox' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Stage' : 'Create Opportunity Stage'}</h1>
      <FormComponent fields={stageFields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityStageInput;
